import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BasketDetail, MedicationDetail } from '../../models/batchpick-state';

export interface FeedEntry {
  med: MedicationDetail;
  basket: BasketDetail;
  pickedAt: string;
}

@Component({
  selector: 'app-activity-feed',
  standalone: true,
  imports: [CommonModule, DatePipe],
  templateUrl: './activity-feed.component.html',
  styleUrl: './activity-feed.component.css',
})
export class ActivityFeedComponent {
  @Input() baskets: BasketDetail[] = [];
  readonly maxRows = 50;

  get entries(): FeedEntry[] {
    const rows: FeedEntry[] = [];
    for (const b of this.baskets) {
      for (const m of b.medications) {
        const pickedAt = m.pickedAt;
        if (pickedAt) rows.push({ med: m, basket: b, pickedAt });
      }
    }
    rows.sort((a, b) => Date.parse(b.pickedAt) - Date.parse(a.pickedAt));
    return rows.slice(0, this.maxRows);
  }

  trackByEntry = (_: number, e: FeedEntry) => e.med.medicationId;
}
